export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_SECTION_TYPE = 'SET_SECTION_TYPE';
export const FETCH_CONTACT_BY_ADDRESS = 'FETCH_CONTACT_BY_ADDRESS';
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';



// WEBPACK FOOTER //
// ./src/components/contact/action.js